module.exports = __webpack_public_path__ + "static/img/Lena_h5.8c54c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Lena_h5.png
// module id = Smnv
// module chunks = 34